import { render } from "./AttendanceSchedule.vue?vue&type=template&id=1779452e&ts=true"
import script from "./AttendanceSchedule.vue?vue&type=script&lang=ts"
export * from "./AttendanceSchedule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__